type LineItemAccess = { canView?: boolean } | null | undefined;

export const canOpenLineItem = (item: LineItemAccess): boolean => item?.canView !== false;

export const getUnviewableIngredientIds = (
    productIngredients: ReadonlyArray<{ ingredient?: { id: number; canView?: boolean } }> | undefined,
): Set<number> =>
    new Set(
        (productIngredients ?? [])
            .map((line) => line.ingredient)
            .filter(
                (ingredient): ingredient is { id: number; canView?: boolean } =>
                    !canOpenLineItem(ingredient) && ingredient !== undefined,
            )
            .map((ingredient) => ingredient.id),
    );
